import React from 'react'
import styled from 'styled-components'
import { RoughBox, chalkSquiggleBg } from '../common/Rough'

const CardOuter = styled.div`
  width: 330px;
  height: 490px;
  cursor: pointer;
  transform: rotate(${(p) => (p.$flip ? '-1.1deg' : '1.1deg')});
  transition: transform 0.25s ease, translate 0.25s ease;
  &:hover {
    transform: rotate(0deg);
    translate: 0 -6px;
  }
  @media (max-width: 400px) {
    width: 82vw;
    height: 460px;
  }
`;

const Image = styled.img`
    width: 100%;
    height: 170px;
    object-fit: cover;
    filter: grayscale(0.1) contrast(1.05);
`

const Tags = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
`

const Tag = styled.span`
    font-family: 'Kalam', cursive;
    font-size: 12px;
    font-weight: 700;
    color: ${({ theme }) => theme.primary};
    padding: 2px 4px;
`

const Details = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 2px 0 2px;
`
const Title = styled.div`
    font-family: 'Caveat', cursive;
    font-size: 26px;
    font-weight: 700;
    color: ${({ theme }) => theme.text_primary};
    overflow: hidden;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`

const Description = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    overflow: hidden;
    margin-top: 6px;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`

const ViewMore = styled.div`
  position: relative;
  display: inline-block;
  margin-top: auto;
  padding-top: 10px;
  font-family: 'Kalam', cursive;
  font-weight: 700;
  font-size: 13px;
  color: ${({ theme }) => theme.primary};

  &::after {
    content: "";
    position: absolute;
    left: -2px;
    right: -2px;
    bottom: 4px;
    height: 10px;
    background-image: ${({ theme }) => chalkSquiggleBg(theme.primary)};
    background-repeat: repeat-x;
    background-size: 40px 10px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  ${CardOuter}:hover &::after {
    opacity: 1;
  }
`;

const ProjectCards = ({ project, flip, setOpenModal }) => {
    return (
        <CardOuter $flip={flip} onClick={() => setOpenModal({ state: true, project: project })}>
            <RoughBox roughness={2.4} strokeWidth={1.8} padding="18px 18px" seed={project.id * 41 + 7} style={{ height: '100%' }}>
                {project.image && <Image src={project.image} />}
                <Details>
                    <Title>{project.title}</Title>
                    <Description>
                        {Array.isArray(project.description) ? (
                            project.description.join(' ')
                        ) : (
                            project.description
                        )}
                    </Description>
                    <Tags>
                        {project.tags?.map((tag, index) => (
                            <Tag key={index}>#{tag.replace(/\s+/g, '')}</Tag>
                        ))}
                    </Tags>
                    <ViewMore>read more ↴</ViewMore>
                </Details>
            </RoughBox>
        </CardOuter>
    )
}

export default ProjectCards
